<template>
    <div class="widget-wrapper">
        <div class="widget-operator">
            <span class="op">
                <i class="delete" @click="deleteWidget"></i>
            </span>
            <span class="op">
                <i class="transfer" @mousedown="transPosition"></i>
            </span>
        </div>
        <component :is="widget.wtType" :data="widget" v-model="hotQuestionData"/>
    </div>
</template>

<script>
import PlatTextLink from "./widgets/PlatTextLink";
import Form from "./widgets/Form";
import HotRecommend from "./widgets/HotRecommend";
import Tool from "./widgets/Tool";
import HList from "./widgets/HList";
import Picture from "./widgets/pictureItem/Picture";
import Package from "./widgets/Package";
import Guides from "./widgets/guidesItem/Index";
import Video from "./widgets/videoItem/Index";
import i18n from "@/i18n";

export default {
    name: "WidgetWrapper",
    components: {
        PlatTextLink,
        Form,
        HotRecommend,
        Tool,
        HList,
        Picture,
        Package,
        Guides,
        Video
    },
    props: ["widget"],
    data() {
        return {
          hotQuestionData: this.widget,
        };
    },
    watch: {
        // 热点推荐组件内部使用v-model，内部数据发生变化时更新状态数据
        hotQuestionData: {
          handler (widget) {
              if (widget.wtType == "HotRecommend") {
                  this.$store.commit('zhiji/editQsUpdateAnswer', {
                      type: 'updateContent',
                      widget,
                  });
              }
            },
            deep: true,
        },
    },
    updated () {
        if (this.hotQuestionData.uId !== this.widget.uId) {
            this.hotQuestionData = this.widget;
        }
    },
    methods: {
        deleteWidget() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.answer.deleteWidgetTip"),
                    confirm: () => {
                        this.$store.commit("zhiji/editQsUpdateAnswer", {
                            type: "deleteContent",
                            widget: this.widget
                        });
                    }
                }
            });
        },
        transPosition(event) {
            this.zhiji.dragStart(event, "widget-wrapper", "v", newIdx => {
                this.$store.commit("zhiji/editQsUpdateAnswer", {
                    type: "tranferContent",
                    widget: {
                        newIdx: newIdx,
                        uId: this.widget.uId
                    }
                });
            });
        }
    }
};
</script>

<style lang="less" scoped>
.widget-wrapper {
    padding-top: 24px;
    display: flex;
    flex-direction: row;

    .widget-operator {
        display: inline-flex;
        flex-direction: column;
        margin-right: 10px;

        .op {
            margin-bottom: 8px;
            cursor: pointer;
            display: inline-flex;
            width: 26px;
            height: 26px;
            border-radius: 50%;
            align-items: center;
            justify-content: center;
            box-shadow: 0px 2px 6px rgba(46, 98, 151, 0.2);
            background: #fff;
        }

        .delete,
        .transfer {
            position: relative;
            display: inline-block;
            width: 16px;
            height: 18px;
            margin: 0 5px 0 5px;
            vertical-align: middle;
            background: url("@{zhijiStaticImagePath}class-spr.png");
        }

        .transfer {
            width: 13px;
            background-position: -113px 0;

            &:hover {
                background-position: -113px -22px;
            }
        }

        .delete {
            background-position: -96px 0;

            &:hover {
                background-position: -96px -22px;
            }
        }
    }

    &.moving {
        user-select: none;
    }
}
</style>
